import { Controller } from "@hotwired/stimulus";

const ITEM_SELECTOR = "[data-sortable-list-target='item']";

export default class extends Controller {
  add(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const container = document.getElementById(button.dataset.recipeEditorContainerId);
    const template = document.getElementById(button.dataset.recipeEditorTemplateId);
    if (!container || !template) return;

    const index = this.nextIndex(container);
    const position = this.nextPosition(container);
    const sectionIndex = button.dataset.recipeEditorSectionIndex;
    let html = template.innerHTML
      .replaceAll("__INDEX__", String(index))
      .replaceAll("__POSITION__", String(position));

    if (sectionIndex !== undefined) {
      html = html.replaceAll("__SECTION_INDEX__", sectionIndex);
    }

    container.insertAdjacentHTML("beforeend", html);
    this.refreshSortableList(container);
    container.querySelector(`${ITEM_SELECTOR}:last-child input, ${ITEM_SELECTOR}:last-child textarea`)?.focus();
  }

  addSection(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const container = document.getElementById(button.dataset.recipeEditorContainerId);
    const template = document.getElementById(button.dataset.recipeEditorTemplateId);
    if (!container || !template) return;

    const sectionIndex = this.nextIndex(container);
    const position = this.nextPosition(container);
    const html = template.innerHTML
      .replaceAll("__SECTION_INDEX__", String(sectionIndex))
      .replaceAll("__ROW_INDEX__", "0")
      .replaceAll("__POSITION__", String(position));

    container.insertAdjacentHTML("beforeend", html);
    this.refreshSortableList(container);
    container.querySelector(`${ITEM_SELECTOR}:last-child input[name*='[title]']`)?.focus();
  }

  removeSection(event) {
    event.preventDefault();

    const section = event.currentTarget.closest("[data-recipe-section]");
    const destroyInput = section?.querySelector("input[type='checkbox'][name$='[_destroy]']");
    if (!section || !destroyInput) return;

    destroyInput.checked = !destroyInput.checked;
    this.refreshSortableList(section.parentElement);
  }

  nextIndex(container) {
    const items = container.querySelectorAll(`:scope > ${ITEM_SELECTOR}`);
    return items.length;
  }

  nextPosition(container) {
    const positions = Array.from(container.querySelectorAll(":scope > [data-sortable-list-target='item'] [data-sortable-list-target='position']"))
      .map((input) => Number.parseInt(input.value, 10))
      .filter((value) => Number.isFinite(value));

    return (positions.length ? Math.max(...positions) : 0) + 1;
  }

  refreshSortableList(element) {
    const controller = this.application.getControllerForElementAndIdentifier(element, "sortable-list");
    controller?.refresh();
  }
}
